<template>
  <div class="column is-one-third-desktop is-one-mobile">
    <article class="card rounded shadow">
      <form @submit.prevent="submit">
        <div class="card-content">
          <h1 class="title has-text-centered">
            <img src="/storage/logo.png" alt="Logo" class="h-32">
          </h1>

        </div>
      </form>
    </article>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  layout: 'auth'
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/home.vue